import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ExportItems, TypeFormats } from 'src/shared/types/exportItem';
import { ExportFileService } from '../command-center/services/export-file.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

type ColumnList = {
  field: string;
  defaultValue?: string;
  isLocalized?: boolean;
  section?: string;
  forceDisplayColumName?: string;
};

type NotificationMessage = {
  section: string;
  field: string;
  defaultMessage?: string;
}

const HORIZONTAL_ALIGNMENT = {
  LEFT: 1,
  CENTER: 2,
  RIGHT: 3,
} as const;

type HorizontalA = typeof HORIZONTAL_ALIGNMENT[keyof typeof HORIZONTAL_ALIGNMENT];

type CellHeader = {
  text?: string;
  mergedCells?: number;
  backgroundColor?: number[];
  fontColor?: number[];
  isLocalizedText?: boolean;
  localizedSection?: string;
  bold?: boolean;
  borderColor?: number[];
  borderLeft?: boolean;
  borderRight?: boolean;
  borderTop?: boolean;
  borderBottom?: boolean;
  format?: string;
  horizontalAlignment?: HorizontalA;
}

type HeaderItem = {
  cells: CellHeader[];
}

type FileName = {
  name: string;
  section: string;
  defaultValue?: string;
}

@Component({
  selector: 'cv-gamification-export',
  templateUrl: './gamification-export.component.html',
  styleUrl: './gamification-export.component.scss'
})
export class GamificationExportComponent implements OnChanges {
  @Input()
  columnList: ColumnList[] = [];

  @Input()
  headerItems: HeaderItem[] = [];

  @Input()
  fileNameExport: FileName = {
    name: '',
    section: ''
  };

  @Input()
  notificationMessage: NotificationMessage = {
    field: 'budget',
    section: 'budget',
  };

  fileName = '';

  @Input()
  getValues: () => Array<Record<string, string>> = () => [];
  
  items: ExportItems = {
    excel: {
      getData: (format) => this.exportHistoryReport(format),
    },
    csv: {
      getData: (format) => this.exportHistoryReport(format),
    }
  };

  constructor(private exportFile: ExportFileService,  private locService: CVLocalizationService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.fileNameExport && changes.fileNameExport.isFirstChange){
      this.initAsync();
    }
  }

  async initAsync() {
    this.fileName = await this.locService.GetLocalText(this.fileNameExport.section, this.fileNameExport.name, this.fileNameExport.defaultValue);
  }

  async exportHistoryReport(format: TypeFormats) {
    const body = {
      columnList: this.columnList,
      headerItems: this.headerItems,
      values: this.getValues(),
      format,
      fileNameExport: this.fileNameExport,
      fileName: this.fileName,
      notification: this.notificationMessage,
    }
    return this.exportFile.exportReport(`/api/v1/gamification/budget/default-export?format=${format}`, body);
  };
}
